import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { MerchantSearchFacadeService } from './search.facade.service';

@Injectable({ providedIn: 'root' })
export class MerchantsSearchService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private searchFacade: MerchantSearchFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
    private literalsFacade: LiteralsFacadeService,
  ) {}

  merchants(): Observable<QcResponseGrid> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/merchant/search';

    let criteriaList: any[] = [];

    if (this.searchFacade.companyName)
      criteriaList.push({
        criteriaType: 'MERCHANT_COMPANY_NAME_CRITERIA',
        companyName: this.searchFacade.companyName,
      });

    if (this.searchFacade.qivosID)
      criteriaList.push({
        criteriaType: 'MERCHANT_CODE_CRITERIA',
        merchantCode: this.searchFacade.qivosID ? this.searchFacade.qivosID : null,
      });

    if (this.searchFacade.getRegistrationDateFromText)
      criteriaList.push({
        criteriaType: 'MERCHANT_REGISTRATION_DATE_CRITERIA',
        registrationDateFrom: this.searchFacade.getRegistrationDateFromText,
      });

    if (this.searchFacade.memberStatus)
      criteriaList.push({
        criteriaType: 'MERCHANT_DELETE_FLAG_CRITERIA',
        deleteFlag: true,
      });

    if (!this.searchFacade.memberStatus)
      criteriaList.push({
        criteriaType: 'MERCHANT_DELETE_FLAG_CRITERIA',
        deleteFlag: false,
      });

    if (this.searchFacade.subscriptionPlan)
      criteriaList.push({
        criteriaType: 'MERCHANT_ATTRIBUTE_CRITERIA',
        attribute: {
          attributeName: 'SubscriptionPlan',
          attributeValue: this.searchFacade.subscriptionPlan,
          dataType: 'STRING',
        },
      });

    if (this.searchFacade.vatNumber)
      criteriaList.push({
        criteriaType: 'MERCHANT_VAT_NUMBER_CRITERIA',
        vatNumber: this.searchFacade.vatNumber.replace(/\s/g, ''),
      });

    if (criteriaList.length === 0)
      criteriaList.push({
        criteriaType: 'MERCHANT_DELETE_FLAG_CRITERIA',
        deleteFlag: false,
      });

    return this.http.post<QcResponseGrid>(
      url,
      {
        criteriaList: criteriaList,
        pagination: {
          page: this.paginatorFacadeService.pageIndex + 1,
          pageSize: this.paginatorFacadeService.itemsNumber,
        },
        sorting: {
          sortingField:
            this.paginatorFacadeService.selectedSortField === 'Creation Date'
              ? 'MERCHANT_CREATION_DATE'
              : 'MERCHANT_COMPANY_NAME',
          sortingOrder:
            this.paginatorFacadeService.selectedOrder ===
            this.literalsFacade.literals.literals['liquid.search.sort.asc']
              ? 'ASC'
              : 'DESC',
        },
      },
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SEARCH, true),
      },
    );
  }
}
